import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

function MakeScrollable({
  children,
  className,
  topCallback,
  bottomCallback,
  parentScrollProps
}) {
  const [showDownArrow, setShowDownArrow] = useState(false)
  const [hasScrolledToBottomOnce, setHasScrolledToBottomOnce] = useState(false)
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false)
  const [hasScrolledToTop, setHasScrolledToTop] = useState(false)
  const containerRef = useRef(null)

  const onScroll = evt => {
    const bottom =
      evt.target.scrollHeight - evt.target.scrollTop - evt.target.clientHeight <
      1
    const top = evt.target.scrollTop === 0

    if (top) {
      setHasScrolledToTop(true)
      if (topCallback) topCallback()
    } else {
      setHasScrolledToTop(false)
    }

    if (bottom) {
      setHasScrolledToBottomOnce(true)
      setHasScrolledToBottom(true)
      if (bottomCallback) {
        bottomCallback()
      }
    } else {
      setHasScrolledToBottom(false)
    }
  }

  const updateScrollableState = () => {
    if (!containerRef.current) return
    const { scrollHeight, clientHeight } = containerRef.current
    setShowDownArrow(scrollHeight > clientHeight)
  }

  useEffect(() => {
    updateScrollableState()
    window.addEventListener('resize', updateScrollableState)
    return () => window.removeEventListener('resize', updateScrollableState)
  }, [])
  return (
    <div
      className={`make-scrollable-container${className ? ` ${className}` : ''}${
        hasScrolledToBottomOnce ? ' reached-bottom' : ''
      }`}
      onScroll={onScroll}
      ref={containerRef}>
      {children}
      {showDownArrow && !hasScrolledToBottomOnce && (
        <div className='gradient'>
          <i className='fa fa-chevron-down' />
        </div>
      )}
    </div>
  )
}

MakeScrollable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  topCallback: PropTypes.func,
  bottomCallback: PropTypes.func
}

export default MakeScrollable
